<template lang="html">
  <div class="page-wrapper">
    <div class="container">
      <div class="coach-detail-info">
        <BaseLoading  opaque :spinning="coachLoading" size="large">
          <div class="heading">
            <h2 class="form-title">
              {{ coach.name }}
            </h2>
            <p class="text-italics text-capitalize position-info">
              {{ coach.position }} at {{ club.name }}
            </p>
            <a-button
              type="primary"
              v-if="canReport && coach.lastLogin"
              @click="handleCoachReport"
              class="next-button save-button"
              >Report This Coach</a-button
            >
          </div>
          <div class="coach-details-container">
            <a-row :gutter="32">
              <a-col :sm="24" :md="10">
                <div class="img-wrap">
                  <img
                    class="coach-image-wrapper"
                    :src="generateImageUrl(coach.image)"
                  />
                </div>
              </a-col>
              <a-col :sm="24" :md="14">
                <div class="coach-description-wrapper">
                  <div class="coach-description-header">
                    <p class="title">Title :</p>
                    <p class="position">{{ coach.position }}</p>
                  </div>
                  <div class="coach-description">
                    <p class="w-space-preline">{{ coach.description }}</p>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </BaseLoading>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Base } from "@/models";

const COACH_STORE_KEY = "coachStore";
const CLUB_STORE_KEY = "clubStore";

export default {
  computed: {
    ...mapGetters({
      coach: `${COACH_STORE_KEY}/coach`,
      coachLoading: `${COACH_STORE_KEY}/coachLoading`,
      club: `${CLUB_STORE_KEY}/club`
    }),
    canReport() {
      return this.exceptBasicPlayer() && Base.userType() === "athlete";
    },
    coachId() {
      return this.$route.params["id"];
    }
  },
  mounted() {
    this.dispatcher();
  },
  methods: {
    async dispatcher() {
      await this.$store.dispatch(`${COACH_STORE_KEY}/getClubCoach`, {
        id: this.coachId
      });
      await this.$store.dispatch(`${CLUB_STORE_KEY}/getClub`, {
        id: this.coach.clubId
      });
    },
    handleCoachReport() {
      let route = `/${Base.profileId()}/complain`;
      sessionStorage["coach-id"] = this.coach.id;
      sessionStorage["coach-type"] = this.coach.uniqueSlug;
      sessionStorage["coach-name"] = this.coach.name;
      this.$router.push({
        path: route
      });
    }
  }
};
</script>
